import { LitElement } from 'lit';
import { Constructable } from './types';

type InteractiveControl = {
	disabled?: boolean;
	readOnly?: boolean;
	control?: HTMLElement;
};

export interface DelegateInteractionMixinInterface {
	focus(): void;
	blur(): void;
	click(): void;
}

/**
 * Mixin that delegates focus(), blur(), and click() to an inner `control`
 * element, gated on the `disabled` (and optionally `readOnly`) state of
 * the host component.
 *
 * Requires the host class to expose:
 *   - `control`  — the inner focusable element (e.g. an <input>, <button>)
 *   - `disabled` — boolean property
 *
 * Optionally reads:
 *   - `readOnly` — when present and true, also blocks click()
 */
export function SDSDelegateInteractionMixin<T extends Constructable<LitElement & InteractiveControl>>(superClass: T): Constructable<DelegateInteractionMixinInterface> & T {
	return class SDSDelegateInteraction extends superClass {
		override focus(): void {
			if (!this.disabled) this.control?.focus();
		}

		override blur(): void {
			if (!this.disabled) this.control?.blur();
		}

		override click(): void {
			if (!this.disabled && !this.readOnly) this.control?.click();
		}
	};
}
